<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  dialog: { type: Boolean, required: true },
  src: { type: String, required: true }
})

const emit = defineEmits(['handleDialog'])

const dialog = computed({
  get() {
    return props.dialog
  },
  set() {
    emit('handleDialog', null)
  }
})
</script>

<template>
  <v-dialog v-model="dialog" width="70%">
    <v-card>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="emit('handleDialog', null)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <v-img :src="src" aspect-ratio="1.75"></v-img>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped></style>
